import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField, } from '../../../../../components';
import { Button, Container, Dialog, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box, Radio, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN } from '../../../../../constants/dropdown';


const initialPatientDataObj = {
    data: [],
    loading: false
};
const initialPosDataObj = {
    data: [],
    loading: false
};


export const RadioServiceAcknowledgement = () => {
    const doctorIDRef = useRef();
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
    const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
    const [originalData, setOriginalData] = useState([]);
    const [input, setInput] = useState('');
    const [isFiltered, setIsFiltered] = useState(false);
    const [opdData, setOpdData] = useState([])
    const [selectedRadio, setSelectedRadio] = useState('ipd_service');
    const [opdFilterData, setOpdFilterData] = useState({ data: [] });
    const [ipdFilterData, setIpdFilterData] = useState({ data: [] });
    const productRef = useRef()
    const [productStock, setProductStock] = useState([])
    const [doctorDropdown, setDoctorDropdown] = useState([])
    const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
    const [patientService, setPatientService] = useState(null)
    const [serviceDropdown, setServiceDropdown] = useState([])
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const pathParts = pathname.split('/');
    const organisation = pathParts[1];
    const user = JSON.parse(localStorage.getItem('user'));

    const [startDateInput, setStartDateInput] = useState('');
    const [endDateInput, setEndDateInput] = useState('');
    const [openListDialog, setOpenListDialog] = useState(false);
    const [serviceAcknowledgementList, setServiceAcknowledgementList] = useState([]);

    const { getValues } = useForm()
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
            })
        ),
        defaultValues: {
            date: new Date().toISOString().split('T')[0],
            time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;

    const IPD_TABLE_HEADER = [
        { header: 'Patient Name', accessor: (row) => row?.patient?.name },
        { header: 'Bill No.', accessor: (row) => row?.bill_no },
        { header: 'Ipd No.', accessor: 'ipd_no' },
        { header: 'Uhid', accessor: (row) => row?.patient?.uhid },
    ];

    const OPD_TABLE_HEADER = [
        { header: 'Patient Name', accessor: (row) => `${row?.patient?.name}` },
        { header: 'Bill No', accessor: (row) => row?.bill_no },
        {
            header: 'Uhid', accessor: "uhid"
        },
    ];

    const getDoctorDropdown = useCallback(async () => {
        const data = await dropdownFetch('doctor');
        if (!selectedRecord && !getValues('consultant')) {
            const [defaultState] = data.filter(({ status }) => status === 'default');
            setValue('consultant', defaultState?._id);
            if (defaultState) {
                setValue('department', defaultState.qualification_details.department);
            }
        }
        setDoctorDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getServiceDropdown = useCallback(async () => {
        const data = await dropdownFetch('service');
        setServiceDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    const getRoomMasterDropdown = useCallback(async () => {
        const data = await dropdownFetch('radiology-room-master');
        setRoomMasterDropdown(data);
    }, [selectedRecord, getValues, setValue]);

    useEffect(() => {
        getDoctorDropdown()
        getServiceDropdown()
        getRoomMasterDropdown()
    }, [getDoctorDropdown, getServiceDropdown, getRoomMasterDropdown])

    const handleRadioChange = (event) => {
        const { name } = event.target;
        setSelectedRadio(name);
    };

    const formSubmit = async (formValues) => {
        setLoading(true);
        const services = patientService
        const serviceBilling = selectedRadio
        const payload = {
            ...formValues,
            services,
            serviceBilling
        };
        try {
            const response = await request('/service-acknowledgement-create', {
                method: 'POST',
                body: {
                    ...payload,
                    createdBy: user.name,
                    organisation
                },
            });
            if (response?.success && response.data) {
                toast(`Successfully ${'created'} Radiology Acknowledgement`, { variant: 'success' });
                setSelectedRecord(response.data);
                fetchIpdPatient()
                fetchOpdPatients()
                setPatientService([])
                reset()
            } else {
                toast(`Failed to ${'create'} Radiology Acknowledgement`, { variant: 'error' });
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            toast("An error occurred while processing your request", { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (productStock && productStock.length > 0) {
            setOriginalData(productStock);
            setIsFiltered(false);
        }
    }, [productStock]);

    const handleProductSearch = (searchValue) => {
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = productStock.filter((item) =>
            item.productDetails[0].product?.toString().toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleProductSearch(newInput);
    };

    const calculateAge = (dob) => {
        const birthDate = new Date(dob);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const handleRowClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', row?.patient?.name)
        setValue('uhid', row?.patient?.uhid)
        setValue('ipd_no', row?.ipd_no)
        setValue('consultant', row?.indoorRegisteration?.consultant_detail?.doctor)
        setValue('gender', row?.patient?.gender)
        setValue('age', calculateAge(row?.patient?.dob))
        setValue('bill_no', row?.bill_no)
        setValue('mobile_no', row?.patient?.mobile_no)
    };

    const handleRowOpdClick = (row) => {
        console.log("HELLLLO ROW", row)
        setValue('patient_name', `${row?.patient?.name}`)
        setValue('gender', `${row?.patient?.gender}`)
        setValue('age', calculateAge(row?.patient.dob))
        setValue('uhid', row?.uhid)
        setValue('consultant', row?.patient?.consultant)
        doctorIDRef.current = row?.consultant?._id;
        setValue('sponsor', row?.sponsor?._id)
        setValue('bill_no', row?.bill_no)
    };

    const fetchOpdPatients = async () => {
        setPatientDataObj({ loading: true });
        try {
            const acknowledgedResponse = await request('/service-acknowledgement-list', { method: 'GET' });
            const acknowledgedRecords = acknowledgedResponse.success
                ? new Set(acknowledgedResponse.data.map(item => `${item.bill_no}_${item.uhid}`))
                : new Set();
            const response = await request('/opd-billing-list', { method: 'GET' });
            if (response.success) {
                const filteredData = response.data
                    .map(patient => {
                        const filteredServiceItems = patient.service_items.filter(item => item.type === "R");
                        return {
                            ...patient,
                            service_items: filteredServiceItems,
                        };
                    })
                    .filter(patient =>
                        patient.service_items.length > 0 &&
                        !acknowledgedRecords.has(`${patient.bill_no}_${patient.uhid}`)
                    );

                setPatientDataObj({ loading: false, data: filteredData });
            } else {
                toast('Error in fetching data', { variant: 'error' });
                setPatientDataObj({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching patient data:', error);
            toast('Error in fetching data', { variant: 'error' });
            setPatientDataObj({ loading: false });
        }
    };

    const fetchIpdPatient = async () => {
        setIndoorRegisterationDataObj({ loading: true });
        try {
            const acknowledgedResponse = await request('/service-acknowledgement-list', { method: 'GET' });
            const acknowledgedRecords = acknowledgedResponse.success
                ? new Set(acknowledgedResponse.data.map(item => `${item.bill_no}_${item.ipd_no}`))
                : new Set();
            const response = await request('/ipd-billing-list', { method: 'GET' });
            if (response.success) {
                const filteredData = response.data
                    .map(patient => {
                        const filteredServiceItems = patient.service_items.filter(item => item.type === "R");
                        return {
                            ...patient,
                            service_items: filteredServiceItems,
                        };
                    })
                    .filter(patient =>
                        patient.service_items.length > 0 &&
                        !acknowledgedRecords.has(`${patient.bill_no}_${patient.ipd_no}`)
                    );
                setIndoorRegisterationDataObj({ loading: false, data: filteredData });
            } else {
                toast('Error in fetching data', { variant: 'error' });
                setIndoorRegisterationDataObj({ loading: false });
            }
        } catch (error) {
            console.error('Error fetching IPD patient data:', error);
            toast('Error in fetching data', { variant: 'error' });
            setIndoorRegisterationDataObj({ loading: false });
        }
    };

    useEffect(() => {
        fetchIpdPatient()
        fetchOpdPatients()
    }, [])

    const PATIENT_STATUS_HEADER = [
        { header: 'Service Name', accessor: (row) => row?.service_name },
        { header: 'Qty', accessor: (row) => row?.quantity },
        { header: 'Rate', accessor: (row) => row?.rate },
        { header: 'Amount', accessor: (row) => row?.amount },
        { header: 'Discount', accessor: (row) => row?.disc_amt },
        { header: 'Room No.', accessor: (row) => row?.room || 'N/A' },
    ];

    useEffect(() => {
        if (opdData && opdData.length > 0) {
            setOpdFilterData({ data: opdData });
            setIsFiltered(false);
        }
    }, [opdData]);

    const handleOpdDataFilter = (searchValue) => {
        const opdDataArray = opdFilterData.data || [];
        const lowercasedInput = searchValue.toLowerCase();

        const filtered = opdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput)
        );
        setOpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };

    useEffect(() => {
        if (indoorRegisterationDataObj && Array.isArray(indoorRegisterationDataObj.data)) {
            setIpdFilterData({ data: indoorRegisterationDataObj.data });
            setIsFiltered(false);
        }
    }, [indoorRegisterationDataObj]);

    const handleIpdDataFilter = (searchValue) => {
        const ipdDataArray = ipdFilterData?.data || [];
        const lowercasedInput = searchValue.toLowerCase();
        const filtered = ipdDataArray.filter((item) =>
            item.uhid.toString().includes(lowercasedInput) ||
            item.ipd_no.toString().includes(lowercasedInput)
        );
        setIpdFilterData((prevData) => ({ ...prevData, data: filtered }));
    };

    const handlePatientRowClick = (row) => {
        setPatientService(row.service_items)
        console.log("HELLLO SERVICE ROW", patientService)
    }

    const handleStartChangeDate = (e) => {
        setStartDateInput(e.target.value);
    };

    const handleEndChangeDate = (e) => {
        setEndDateInput(e.target.value);
    };

    const handleSearchByDate = async () => {
        setIndoorRegisterationDataObj({ loading: true, data: [] });
        try {
            const query = {};
            if (startDateInput && endDateInput) {
                query.startDate = startDateInput;
                query.endDate = endDateInput;
            }
            const response = await request('/ipd-billing-list', {
                method: 'GET',
                query: query
            });

            if (response.success && Array.isArray(response.data)) {
                const filteredData = response.data.filter(
                    (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
                );
                setIndoorRegisterationDataObj({ loading: false, data: filteredData });
            } else {
                toast('Error in fetching data', { variant: 'error' });
                setIndoorRegisterationDataObj({ loading: false, data: [] });
            }
        } catch (error) {
            console.error('Error during search:', error);
            toast('Error during search', { variant: 'error' });
            setIndoorRegisterationDataObj({ loading: false, data: [] });
        }
    }

    const handleListWindow = async () => {
        setOpenListDialog(true);
        setServiceAcknowledgementList({ loading: true });
        try {
            const response = await request('/service-acknowledgement-list', { method: 'GET' });
            if (response.success) {
                setServiceAcknowledgementList({ loading: false, data: response.data });
            } else {
                toast('Error in fetchingggggggg data', { variant: 'error' });
                setServiceAcknowledgementList({ loading: false });
            }
        } catch (error) {
            //   console.error('Error fetching patient data:', error);
            toast('Error in fetching data', { variant: 'error' });
            setServiceAcknowledgementList({ loading: false });
        }
    };

    const SERVICE_ACKNOWL_LIST = [
        { header: 'Doc No', accessor: (row) => row?.doc_no },
        { header: 'Doc date', accessor: (row) => formatDate(row?.date) },
        { header: 'Uhid', accessor: (row) => row?.uhid },
        { header: 'Ipd No', accessor: (row) => row?.ipd_no },
        { header: 'Patient Name', accessor: (row) => row?.patient?.first_name },
        { header: 'Gender', accessor: (row) => row?.patient?.gender },
        { header: 'Age', accessor: (row) => calculateAge(row?.patient?.dob) },
        { header: 'Consiltant', accessor: (row) => row?.patient?.consultant?.name },
        { header: 'Mobile No', accessor: (row) => row?.patient?.address?.mobile },
        { header: 'Bill No', accessor: (row) => row?.bill_no },
    ];

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    
    // const ageString = data.age;
    // const years = ageString.match(/\d+Y/); // This will match digits followed by "Y"

    const handleCancelRecord = async () => {
        setLoading(true);
        const response = await request('/patient-registeration-cancel', {
          method: 'DELETE',
          params: selectedRecord._id
        });
        if (response?.success) {
          toast('Successfully Cancelled Patient Registeration', { variant: 'success' });
          setSelectedRecord();
        } else {
          toast('Failed to Cancelled Patient Registeration', { variant: 'error' });
        }
        setLoading(false);
      };


    return (
        <>
            <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none', width: '100%', height: 'auto' }} >
                <Container
                    sx={{
                        mt: 2,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ mb: 2, borderBottom: '0px solid', borderColor: 'grey.300' }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Radiology Service Acknowledge
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>

                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                >
                                    Acknowledgement
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    onClick={handleListWindow}
                                >
                                    List
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    onClick={() => {
                                        window.open(`/print${pathname}?refId=${selectedRecord}`, '_blank');
                                    }}
                                    disabled={!selectedRecord || currentAction}
                                >
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained"
                                    onClick={() => {
                                        setCurrentAction('');
                                    }}
                                > Exit </CustomButtonn>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={5} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>

                                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="center"
                                        sx={{ mt: 1, mb: 1, width: '100%', gap: 2, justifyContent: 'space-between' }} >
                                        <Typography sx={{
                                            flex: 1, fontWeight: 700, fontSize: '1.4rem', textAlign: 'center' // Centers the label text
                                        }} >
                                            From Date
                                        </Typography>
                                        <MuiTextField sx={{
                                            flex: 2, // This ensures the input takes more space
                                            '& .MuiOutlinedInput-root': {
                                                padding: '0',
                                                fontSize: '14px'
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                padding: '8px 14px'
                                            },
                                            '& .MuiInputLabel-root': {
                                                fontSize: '1.2rem' // Adjust label font size
                                            }
                                        }}
                                            variant="outlined"
                                            name="from_date"
                                            type="date"
                                            onChange={handleStartChangeDate}
                                            value={startDateInput}
                                        />

                                        <Typography
                                            sx={{ flex: 1,
                                                fontWeight: 700,
                                                fontSize: '1.4rem',
                                                textAlign: 'center' // Centers the label text
                                            }}
                                        >
                                            To Date
                                        </Typography>

                                        <MuiTextField
                                            sx={{
                                                flex: 2, // This ensures the input takes more space
                                                '& .MuiOutlinedInput-root': {
                                                    padding: '0',
                                                    fontSize: '14px'
                                                },
                                                '& .MuiOutlinedInput-input': {
                                                    padding: '8px 14px'
                                                },
                                                '& .MuiInputLabel-root': {
                                                    fontSize: '1.2rem' // Adjust label font size
                                                }
                                            }}
                                            name="to_date"
                                            variant="outlined"
                                            type="date"
                                            onChange={handleEndChangeDate}
                                            value={endDateInput}
                                        />
                                        <Button variant="contained"
                                            disabled={!startDateInput || !endDateInput}
                                            onClick={handleSearchByDate}
                                        >
                                            Search
                                        </Button>
                                    </Stack>
                                    <Stack spacing={0.2} direction="row" alignItems="center">
                                        <Radio
                                            name="ipd_service"
                                            checked={selectedRadio === 'ipd_service'}
                                            onChange={handleRadioChange}
                                        />
                                        <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Ipd Service Billing</Typography>

                                        <Radio
                                            name="opd_service"
                                            checked={selectedRadio === 'opd_service'}
                                            onChange={handleRadioChange}
                                        />
                                        <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>Opd Service Billing</Typography>
                                    </Stack>
                                    <Grid item sx={{ display: 'flex', flexDirection: 'column', marginTop: "1%" }}>
                                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                                            <MuiTextField
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        padding: '0',
                                                        border: '1px solid #66ccff', // Set the border color and width
                                                        borderRadius: '8px', // Set the border radius (optional)
                                                        '&:hover': {
                                                            borderColor: '#66ccff', // Set border color on hover (optional)
                                                        },
                                                        '&.Mui-focused': {
                                                            borderColor: '#66ccff', // Set border color when focused (optional)
                                                        },
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        padding: '8px 14px',
                                                        fontSize: '14px', // Font size
                                                    },
                                                }}
                                                label="Search Admitted Patient"
                                                variant="outlined"
                                                value={input}
                                                onChange={handleChange}
                                                inputRef={productRef}
                                            />
                                        </Stack>

                                        {
                                            selectedRadio === 'ipd_service' ? (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', marginTop: '1%' }}
                                                    data={indoorRegisterationDataObj.data || []}
                                                    columns={IPD_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowClick(row);
                                                        handlePatientRowClick(row)
                                                    }}
                                                />
                                            ) : (
                                                <Table
                                                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', marginTop: '1%' }}
                                                    data={patientDataObj.data || []}
                                                    columns={OPD_TABLE_HEADER}
                                                    size="small"
                                                    onRowClick={(row) => {
                                                        handleRowOpdClick(row);
                                                        handlePatientRowClick(row)
                                                    }}
                                                />
                                            )
                                        }
                                    </Grid>
                                </Grid>

                                <Grid item xs={7} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                    <Stack sx={{ border: "0px solid grey", padding: "5px", borderRadius: "5px", boxShadow: '0px 2px 2px #0099ff' }} spacing={0.5} direction="row">
                                        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Doc No.</Typography>

                                                <TextField
                                                    disabled
                                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                                    name="doc_no"
                                                    placeholder="Doc No."
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Uhid/Ipd No.</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="uhid"
                                                    placeholder="Enter Uhid"
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="ipd_no"
                                                    placeholder="Enter Ipd No."
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Gender/Age</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.4 }}
                                                    name="gender"
                                                    placeholder="Select Gender"
                                                    menus={GENDER_DROPDOWN}
                                                />
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.4 }}
                                                    name="age"
                                                    placeholder="Age"
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Mobile No.</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8 }}
                                                    name="mobile_no"
                                                    placeholder="Mobile No."
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Doc Date</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                                                    name="date"
                                                    type="date"
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Patient Name</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8 }}
                                                    name="patient_name"
                                                    placeholder="Patient Name"
                                                />

                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Consultant</Typography>
                                                <SelectTag
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    formControlSX={{ flex: 0.8 }}
                                                    name="consultant"
                                                    placeholder="Select Consultant"
                                                    menus={doctorDropdown}
                                                />
                                            </Stack>
                                            <Stack spacing={0.5} direction="row" alignItems="center">
                                                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Bill No</Typography>
                                                <TextField
                                                    disabled={!['new', 'edit'].includes(currentAction)}
                                                    sx={{ flex: 0.8 }}
                                                    name="bill_no"
                                                />
                                            </Stack>
                                        </Grid>
                                    </Stack>
                                    <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, marginTop: '1%' }}>
                                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3 }}>
                                            <Table
                                                containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                                                data={patientService || []}
                                                columns={PATIENT_STATUS_HEADER}
                                                size="small"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </FormProvider>
                </Container >
            </Paper >

            <Dialog
                open={openListDialog}
                onClose={() => {
                    setOpenListDialog(false);
                    setStartDateInput('');
                    setEndDateInput('');
                }}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={0}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Radiology Service Acknowledge List Window
                    </Typography>
                    <IconButton
                        onClick={() => {
                            setOpenListDialog(false);
                            setStartDateInput('');
                            setEndDateInput('');
                        }}
                    >
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                    <MuiTextField
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '14px'
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 10px'
                                // fontSize: '14px'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        label="Search Patient"
                        placeholder="Search Patient"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                    />
                </Stack>
                <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        mt: 1,
                        mb: 1,
                        width: '60%',
                        gap: 2,
                        justifyContent: 'space-between'
                    }}
                >
                    <Typography
                        sx={{
                            flex: 1,
                            fontWeight: 700,
                            fontSize: '1.4rem',
                            textAlign: 'center' // Centers the label text
                        }}
                    >
                        From Date
                    </Typography>

                    <MuiTextField
                        sx={{
                            flex: 2, // This ensures the input takes more space
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '14px'
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 14px'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        variant="outlined"
                        name="from_date"
                        type="date"
                        onChange={handleStartChangeDate}
                        value={startDateInput}
                    />

                    <Typography
                        sx={{
                            flex: 1,
                            fontWeight: 700,
                            fontSize: '1.4rem',
                            textAlign: 'center' // Centers the label text
                        }}
                    >
                        To Date
                    </Typography>

                    <MuiTextField
                        sx={{
                            flex: 2, // This ensures the input takes more space
                            '& .MuiOutlinedInput-root': {
                                padding: '0',
                                fontSize: '14px'
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '8px 14px'
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1.2rem' // Adjust label font size
                            }
                        }}
                        name="to_date"
                        variant="outlined"
                        type="date"
                        onChange={handleEndChangeDate}
                        value={endDateInput}
                    />
                    <Button variant="contained" disabled={!startDateInput || !endDateInput} onClick={handleSearchByDate}>
                        Search
                    </Button>
                </Stack>
                <Table
                    sx={{ mt: 0.5 }}
                    columns={SERVICE_ACKNOWL_LIST}
                    data={serviceAcknowledgementList.data || []}
                    loading={serviceAcknowledgementList.loading}
                    onRowClick={(row) => {
                        console.log(row,"ROWSSSSSS")
                      setOpenListDialog(false)
                        setValue('doc_no', row?.doc_no)
                        setValue('date', row?.date?.split('T')[0]);
                        setValue('uhid', row?.uhid)
                        setValue('ipd_no', row?.ipd_no)
                        setValue('patient_name', (row?.patient?.first_name))
                        setValue('gender', row?.patient?.gender)
                        setValue('age', calculateAge(row?.patient?.dob))
                        setValue('consultant', (row?.patient?.consultant?._id))
                        setValue('mobile_no', row?.patient?.address?.mobile)
                        setValue('bill_no', row?.bill_no)
                        setSelectedRecord(row?._id)
                    }}
                />
            </Dialog>
        </>
    );
};
